import { render, staticRenderFns } from "./ShowPicture.vue?vue&type=template&id=73cce1ba&scoped=true&"
import script from "./ShowPicture.vue?vue&type=script&lang=js&"
export * from "./ShowPicture.vue?vue&type=script&lang=js&"
import style0 from "./ShowPicture.vue?vue&type=style&index=0&id=73cce1ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cce1ba",
  null
  
)

export default component.exports